"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuickBuyButtonOnClickHandler = void 0;
var _openProductInfoDialog = require("@ori-events/open-product-info-dialog");
var _openProductInfoDialog2 = require("./openProductInfoDialog");
var _openShadePicker = require("./openShadePicker");
const getQuickBuyButtonOnClickHandler = (product, analyticsData) => {
  if (product.hasAutosubscribe) {
    return (0, _openProductInfoDialog2.openProductInfoDialog)(_openProductInfoDialog.DialogMode.StandardBuy, product.code, analyticsData);
  } else if (product.isMultishade) {
    return (0, _openShadePicker.openShadePicker)(product, analyticsData);
  }
  return undefined;
};
exports.getQuickBuyButtonOnClickHandler = getQuickBuyButtonOnClickHandler;
//# sourceMappingURL=getQuickBuyButtonOnClickHandler.js.map